<template lang="html">
  <el-form ref="form" v-form :model="form" addAction="obdConfig/saveObdConfig.action" editAction="obdConfig/updateObdConfig.action" selectAction="obdConfig/selectObdConfig.action"

   :rules="rules" label-width="150px">
      <el-col :span="12">

          <el-form-item label="名称" prop="name">
              <el-input type="text" v-model="form.name" placeholder="如 VIP+省心智联套餐"></el-input>
          </el-form-item>

          <el-form-item label="价格" prop="money">
              <el-input v-model="form.money" placeholder="请输入金额"  type="number" step="0" ></el-input>
          </el-form-item>

          <el-form-item label="上传内容介绍图" prop="contentImg">
              <el-upload :http-request="onHttpRequest" accept="image/*" :on-success="uploadSuccess1"  class="avatar-uploader" v-model="form.contentImg" action="upload/uploadPic" :show-file-list="false" :data="{floder:'obdConfig'}"  >
                  <img v-if="form.showContentImg" :src="form.showContentImg" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div slot="tip" class="el-upload__tip">  <p>建议尺寸：750*460px <span style="color:red;">最多1张</span></p></div>
              </el-upload>

          </el-form-item>

          <el-form-item label="经纪人奖励" prop="agentMoney">
              <el-input   v-model="form.agentMoney" placeholder="请输入金额"  type="number" step="0" ></el-input>
          </el-form-item>

          <el-form-item label="合伙人奖励" prop="dealerMoney">
              <el-input   v-model="form.dealerMoney" placeholder="请输入金额"  type="number" step="0" ></el-input>
                <p style="color:gray">若合伙人直拓，则获得经纪人奖励+合伙人奖励</p>
          </el-form-item>

      </el-col>

      <el-col>
          <el-form-item>
              <el-button type="button"  @click="submitForm('form')">保存</el-button>

          </el-form-item>

      </el-col>

  </el-form>
</template>

<script>
import Config from '@/framework/configs/Config'
import obdConfig from '@/framework/models/obdConfig'

import BasicPager from '@/mixins/BasicPager'

export default {
  extends: BasicPager,
  components: {

  },
  data: function () {
    return {
      readonly: false,
      baseUrl: Config.baseUrl,
      isAdmin: null,
      imageUrl: Config.imageUrl,
      form: {
        id: null,
        name: null,
        money: null,
        agentMoney: null,
        dealerMoney: null,
        contentImg: null,
        showContentImg: null,
        channelId: null
      },
      rules: {
        name: [{
          required: true,
          message: '名称不能为空！'
        }],
        money: [{
          required: true,
          trigger: 'change',
          message: '金额不能为空！'
        }],
        agentMoney: [{
          required: true,
          trigger: 'change',
          message: '经纪人奖励不能为空！'
        }],
        dealerMoney: [{
          required: true,
          trigger: 'change',
          message: '合伙人奖励不能为空！'
        }],
        contentImg: [{
          required: true,
          message: '上传内容介绍图不能为空！'
        }],
        channelId: [{
          required: true,
          message: '渠道不能为空'
        }]
      }
    }
  },
  created: function () {
    this.selectObdConfig()
  },
  methods: {

    uploadSuccess1: function (data) {
      this.form.showContentImg = this.imageUrl + data.datas[0]
      this.form.contentImg = data.datas[0]
    },
    selectObdConfig: function () {
      let _this = this
      let userInfo = JSON.parse(localStorage.userInfo)
      if (userInfo.loginPath == 'channel') {
        this.form.channelId = this.loginInfo.id
      }

      let params = {
        channelId: this.form.channelId
      }

      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            _this.readonly = true
            _this.form = dataInfo.datas
          }
        }
      }

      obdConfig.selectObdConfig(_this, params, listener)
    },
    submitForm: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveObdConfig()
        } else {
          return false
        }
      })
    },
    saveObdConfig: function () {
      let _this = this
      let userInfo = JSON.parse(localStorage.userInfo)
      if (userInfo.loginPath == 'channel') {
        this.form.channelId = this.loginInfo.id
      }
      let params = this.form
      params.channelId = this.form.channelId

      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message.success('保存成功')
            _this.selectObdConfig()
          } else {
            _this.$message.error('保存失败')
          }
        }
      }
      if (this.form.id) {
        obdConfig.updateObdConfig(_this, params, listener)
      } else {
        obdConfig.saveObdConfig(_this, params, listener)
      }
    }

  }
}
</script>
